// If we ever get rid of the old interaction form, we can delete this file

import { fetchFromGraphql } from 'entities/helpers/gqlCall';

const gql = String.raw;

export const getHouseholdMembersForContact = async (contact) => {
  const query = gql`
    query ($id: BigInt!) {
      contact(id: $id) {
        household_members {
          id
          contact_attributes {
            name_full
          }
        }
      }
    }
  `;

  const params = { id: contact.id };
  try {
    const result = await fetchFromGraphql(query, params, 'getHouseholdMembersForContact');

    return result?.contact?.household_members || [];
  } catch (e) {
    console.error(`Failed to fetch household members. Error: ${e}`);
    return [];
  }
};
